import React from "react";
import { DialogContent } from "@material-ui/core";
import FixedPositionDialog from "../../../../../elements/FixedPositionDialog";
import DialogTitleWithCloseIcon from "../../../../../elements/DialogTitleWithCloseIcon";
import PublicUrlContainer from "./PublicUrlContainer";
import I18nText from "../../../../../elements/I18nText";

const PublicUrlDialog = ({ device, onClose }) => {
  return (
    <>
      <FixedPositionDialog open={true} scroll="body" fullWidth maxWidth="xs">
        <DialogTitleWithCloseIcon onClose={onClose}>
          <I18nText>devices.settings.metadata.sections.publicUrl</I18nText>
        </DialogTitleWithCloseIcon>
        <DialogContent>
          <PublicUrlContainer device={device} onClose={onClose} />
        </DialogContent>
      </FixedPositionDialog>
    </>
  );
};

export default PublicUrlDialog;
